import { defineStore } from "pinia";
import { ref } from "vue";
import api from "../api";
import type { Industry } from "../types/organization/Industry";

export const useIndustriesStore = defineStore("industries", () => {
	const industries = ref<Industry[]>([]);
	const loaded = ref(false);
	const loading = ref(false);
	const loadFailed = ref(false);

	async function load(force = false): Promise<void> {
		if (loading.value) {
			return;
		}
		if (loaded.value && !force) {
			return;
		}
		loading.value = true;
		loadFailed.value = false;
		try {
			const result = await api.getIndustries();
			industries.value = Array.isArray(result) ? result : [];
			loaded.value = true;
		} catch (error) {
			console.error("Failed to load industries", error);
			loadFailed.value = true;
		} finally {
			loading.value = false;
		}
	}

	return {
		industries,
		loaded,
		loading,
		loadFailed,
		load
	};
});
